import Link from 'next/link'
import PropTypes from 'prop-types'

// Internal components
import Button from '../Button/Button'
import LazyImage from '../LazyImage/LazyImage'
import Svg from '../Svg/Svg'

// returns a modified homepage item using the hardcoded data
const generateQuickLink = (item, index) => {
  const createMarkup = (text) => ({ __html: text })
  const href = item?.symbolCardLink?.[0]?.symbolCardPage?.url

  return (
    <Link href={`${href}`} prefetch={false} key={`CorrelatedColumn-listItem-${index}`}>
      <a className="CorrelatedColumn-link">
        <div className="CorrelatedColumn-figure">
          <Svg id={`symbol-${item.symbolCardImage.toLowerCase()}`} modifiers={['CorrelatedColumn-svg']} />
        </div>
        <div className="CorrelatedColumn-copy">
          <h4 className="CorrelatedColumn-title">{item.symbolCardTitle}</h4>
          <div
            className="CorrelatedColumn-description"
            dangerouslySetInnerHTML={createMarkup(item.symbolCardDescription)}
          ></div>
        </div>
      </a>
    </Link>
  )
}

const generateColumnItem = (item, index) => {
  const { cover, introText, title, url } = item
  const introTextHtml = typeof introText === 'string' ? introText : introText?.html
  const createMarkup = (text) => ({ __html: text })

  if (!url) return <div key={`CorrelatedColumn-listItem-${index}`}></div>

  return (
    <Link href={url} prefetch={false} key={`CorrelatedColumn-listItem-${index}`}>
      <a className="CorrelatedColumn-link">
        {cover?.[0].CoverFigureRight?.[0]?.image && (
          <div className="CorrelatedColumn-figure">
            <LazyImage
              image={cover[0].CoverFigureRight[0].image}
              alt={cover[0].CoverFigureRight[0]?.alt}
              sizes={'(min-width: 1100px) 460px, (min-width: 760px) 280px, 140px'}
              modifiers={['LazyImage--correlatedColumn']}
            />
          </div>
        )}
        <div className="CorrelatedColumn-copy">
          <h4 className="CorrelatedColumn-title">{title}</h4>
          <div className="CorrelatedColumn-description" dangerouslySetInnerHTML={createMarkup(introTextHtml)}></div>
        </div>
      </a>
    </Link>
  )
}

const CorrelatedColumn = (props) => {
  const { column, title, button, isSecondColumn } = props

  return (
    <div className="CorrelatedColumn">
      <h3 className={title ? 'CorrelatedColumn-header' : 'CorrelatedColumn-header is-empty'}>{title || ''}</h3>
      {column.map((columnItem, itemIndex) => {
        if (!columnItem.symbolCardImage) {
          return generateColumnItem(columnItem, itemIndex)
        } else {
          return generateQuickLink(columnItem, itemIndex)
        }
      })}
      {button && (
        <Button
          href={button?.url || false}
          // link={{ href: button?.link }}
          label={button.text || button.customText}
          icon={{ id: 'icon-chevron-right' }}
          modifiers={[`Button--correlated${isSecondColumn ? 'Secondary' : ''}`]}
        />
      )}
    </div>
  )
}

CorrelatedColumn.propTypes = {
  column: PropTypes.array,
  title: PropTypes.any,
  button: PropTypes.any,
  isSecondColumn: PropTypes.bool
}

export default CorrelatedColumn
